export default __webpack_public_path__ + "static/media/12_photo.37e0aa74.jpg";